import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderHighlightData} from '../VanillaReader/VanillaReaderModel';
import {IVanillaReaderUiComponentController} from './IVanillaReaderUiComponentController';
import {VanillaReaderUI} from './VanillaReaderUI';

export interface VanillaReaderUiDialogHighlightController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiDialogHighlightController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogHighlight` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogHighlight
 *
 * */
export class VanillaReaderUiDialogHighlightController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogHighlight.onHighlightAdd(vanillaReaderUiContext._onDialogHighlightAdd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onHighlightDelete(vanillaReaderUiContext._onDialogHighlightDelete.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onHighlightUpdate(vanillaReaderUiContext._onDialogHighlightUpdate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onGotoHighlightLocation(vanillaReaderUiContext._onDialogHighlightGoToLocation.bind(vanillaReaderUiContext));
    }

    _onDialogHighlightAdd(highlight: IVanillaReaderHighlightData): void {
        this.vanillaReaderAPI?.addHighlight(highlight);
    };

    _onDialogHighlightDelete(highlight: IVanillaReaderHighlightData): void {
        this.vanillaReaderAPI?.deleteHighlight(highlight.locator);
    };

    _onDialogHighlightUpdate(highlight: IVanillaReaderHighlightData): void {
        this.vanillaReaderAPI?.updateHighlight(highlight);
    };

    _onDialogHighlightGoToLocation(locator: string): void {
        this.dialogHighlight.close(true, false);
        this.navigateTo(locator);
    };
}
